export async function GenerateJWTCyberService(dataToSend) {
  try {
    const apiUrl = process.env.REACT_APP_GenerateJWTCyber;
 
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify( dataToSend )
    });

    if (!response.ok) throw new Error('Error al obtener datos');
    
    return await response.json();
  } catch (error) {
    console.error('Error al llamar al API:', error);
    throw error;
  }
}
